import React from 'react';
import ScrapingShell from '../../../components/ScrapingShell';

/** Admin V2 Events — Phase 2 shell. Feature : pages.events.admin. */
const AdminV2Events = () => (
  <ScrapingShell
    titleKey="eventsV2.title" titleFallback="Live events"
    bodyKey="eventsV2.body"
    bodyFallback="Live events and match history come from the scraping pipeline (Backstage live data). Enabled per tenant once the data source is wired."
  />
);

export default AdminV2Events;
